export default __webpack_public_path__ + "static/media/placeholder_dummy2016-consulting01-mobile-de.28dc5bd6.png";